/* Header behaviour: mobile menu toggle for the .lp-hd markup */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lp-burger]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var hd = b.closest('[data-lp-header]');
    if (!hd) return;
    var open = hd.classList.toggle('is-navopen');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });

  /* close the mobile menu after tapping a link */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-lp-nav] a');
    if (!link) return;
    var hd = link.closest('[data-lp-header]');
    if (hd) hd.classList.remove('is-navopen');
  });

  /* and on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var hd = document.querySelector('[data-lp-header].is-navopen');
    if (hd) hd.classList.remove('is-navopen');
  });
})();
